<template>
  <div class="walletHistory" style="heigth:100%">
    <!-- <h5>译贝历史</h5> -->
    <!-- <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane label="译贝收入" name="ybIncome">
        <ul class="tabBox" v-if="activeName==='ybIncome'">
          <li v-for="(item,index) in incomeList" :key="index">
            <span class="ybIcon" :class="item.ruleCode"></span>
            <span class="ybTit">{{item.remark}}</span>
            <span class="ybNum">+{{item.amountFreebie | number_format}}<i> 译贝</i></span>
            <span class="ybTime">{{item.updateTime}}</span>
          </li>
        </ul>
        <div v-if="incomeList.length<1" class="noData">
          <img src="../../assets/imgs/memory/userCenter/yb-zc.png" alt="暂无数据">
          <p>暂无译贝收入</p>
        </div>
      </el-tab-pane>
      <el-tab-pane label="译贝支出" name="ybExpenditure">
        <ul class="tabBox" v-if="activeName==='ybExpenditure'">
          <li v-for="(item,index) in expenditureList" :key="index">
            <span class="ybIcon ybExpenditure"></span>
            <span class="ybTit">{{item.remark}}</span>
            <span class="ybNum">-{{item.amount | number_format}}<i> 译贝</i></span>
            <span class="ybTime">{{item.updateTime}}</span>
          </li>
        </ul>
        <div v-if="expenditureList.length<1" class="noData">
          <img src="../../assets/imgs/memory/userCenter/yb-zc.png" alt="暂无数据">
          <p>暂无译贝支出</p>
        </div>
      </el-tab-pane>
    </el-tabs> -->
    <div class="tableMain" style="height: calc(100% - 45px);">
      <ul class="tabBox">
        <li v-for="(item,index) in ybList" :key="index">
          <span class="ybIcon" :class="item.orderType==2 && 'ybExpenditure'"></span>
          <span class="ybTit">{{item.remark}}</span>
          <span class="ybNum">{{item.amountFreebie | number_format}}<i> 译贝</i></span>
          <span class="ybTime">{{item.updateTime}}</span>
        </li>
      </ul>
      <div v-if="ybList.length<1" class="noData">
        <img src="../../assets/imgs/memory/userCenter/yb-zc.png" alt="暂无数据">
        <p>暂无译贝记录</p>
      </div>
    </div>

    <el-pagination class="page" background layout="total,prev, pager, next" :total="totalRows" :page-size="20"
      :pager-count="5" :current-page.sync="currentPage" prev-text="上一页" next-text="下一页"
      @current-change="handleCurrentChange"></el-pagination>
  </div>
</template>

<script>

export default {
  name: "walletHistory",
  data() {
    return {
      activeName: "ybIncome",
      totalRows: 0,
      currentPage: 1,
      incomeList: [],
      expenditureList: [],
      ybList:[],
      loadinginstace: false
    };
  },
  computed: {
  },
  created() {
    this.getYbPage(1)
  },
  updated() {

  },
  filters: {
    number_format(number, decimals, dec_point, thousands_sep) {
      /*
       * 参数说明：
       * number：要格式化的数字
       * decimals：保留几位小数
       * dec_point：小数点符号
       * thousands_sep：千分位符号
       * */
      number = (number / 100 + '').replace(/[^0-9+-Ee.]/g, '');
      var n = !isFinite(+number) ? 0 : +number,
        prec = !isFinite(+decimals) ? 2 : Math.abs(decimals),
        sep = (typeof thousands_sep === 'undefined') ? ',' : thousands_sep,
        dec = (typeof dec_point === 'undefined') ? '.' : dec_point,
        s = '',
        toFixedFix = function (n, prec) {
          var k = Math.pow(10, prec);
          return '' + Math.ceil(n * k) / k;
        };

      s = (prec ? toFixedFix(n, prec) : '' + Math.round(n)).split('.');
      var re = /(-?\d+)(\d{3})/;
      while (re.test(s[0])) {
        s[0] = s[0].replace(re, "$1" + sep + "$2");
      }

      if ((s[1] || '').length < prec) {
        s[1] = s[1] || '';
        s[1] += new Array(prec - s[1].length + 1).join('0');
      }
      return s.join(dec);
    }
  },
  methods: {
    // 译贝列表
    async getYbPage(page) {
      this.loadinginstace = this.$loading({ fullscreen: true });
      const params = {
        page,
        rows: 20,
        filter: {},
        sort: { createTime: "desc" }
      }
      const res = await this.catReq1Service('/api/v1/user/query_account_records', params);
      this.loadinginstace.close(); // loading清除
      if (res.success) {
        this.totalRows = res.totalRows;
        this.ybList = res.list;
      } else {
        this.list = []
      }
    },
    // 译贝收入列表
    async getIncomePage(page) {
      this.loadinginstace = this.$loading({ fullscreen: true });
      const params = {
        page,
        rows: 20,
        filter: {},
        sort: { createTime: "desc" }
      }
      const res = await this.catReq1Service('/api/v1/user/account_recharge_order', params);
      this.loadinginstace.close(); // loading清除
      if (res.success) {
        this.totalRows = res.totalRows;
        this.incomeList = res.list;
      } else {
        this.list = []
      }
    },
    // 译贝支出列表
    async getExpenditurePage(page) {
      this.loadinginstace = this.$loading({ fullscreen: true });
      const params = {
        page,
        rows: 20
      }
      const res = await this.catReq1Service('/api/v1/user/account_consume_order', params);
      this.loadinginstace.close(); // loading清除
      if (res.success) {
        this.totalRows = res.totalRows;
        this.expenditureList = res.list;
      } else {
        this.list = []
      }
    },
    handleClick(tab, event) {
      if (tab.name == "ybIncome") {
        this.getIncomePage(1)
      } else {
        this.getExpenditurePage(1)
      }

    },
    handleCurrentChange(val) {
       this.getYbPage(val)
      // if (this.activeName === 'ybIncome') {
      //   this.getIncomePage(val)
      // } else {
      //   this.getExpenditurePage(val)
      // }
    }
  },
};
</script>
<style lang="less" scoped>
.walletHistory {
  text-align: left;
  margin: 0 auto;
  width: 77%;
  height: calc(100% - 72px);
  position: relative;
  // h5 {
  //   font-size: 16px;
  //   font-weight: bold;
  //   color: rgba(27, 28, 28, 1);
  //   margin-bottom: 30px;
  // }
  /deep/.el-tabs {
    height: calc(100% - 50px);
    .el-tabs__header {
      overflow: hidden;
    }
    .el-tabs__item {
      font-size: 16px;
      font-weight: bold;
    }
  }
  .tableMain{
    height: calc(100% - 45px);
    position: relative;
    overflow: auto;
  }
  .noData {
    text-align: center;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%,-60%);
    p {
      font-size: 16px;
      font-weight: 400;
      color: rgba(102, 102, 102, 1);
      margin-top: 30px;
    }
  }
  .tabBox {
    // height: calc(100% - 88px);
    li {
      margin-bottom: 25px;
      font-size: 14px;
      font-weight: 400;
      color: rgba(51, 51, 51, 1);
      height: 24px;
      line-height: 24px;
      span {
        display: inline-block;
      }
      .ybIcon {
        width: 20px;
        height: 20px;
        background: url("../../assets/imgs/memory/userCenter/income.png") center
          no-repeat;
        position: relative;
        top: 4px;
        margin-right: 5px;
      }
      .ybExpenditure {
        background: url("../../assets/imgs/memory/userCenter/expenditure.png")
          center no-repeat;
      }
      .user_register {
        background: url("../../assets/imgs/memory/userCenter/register.png")
          center no-repeat;
      }
      .user_identify {
        background: url("../../assets/imgs/memory/userCenter/register.png")
          center no-repeat;
      }
      .company_identify {
        background: url("../../assets/imgs/memory/userCenter/enterprise_certification.png")
          center no-repeat;
      }
      .ybTit {
        width: 280px;
      }
      .ybNum {
        width: 170px;
        font-size: 16px;
        font-weight: bold;
        color: rgba(51, 51, 51, 1);
        i {
          font-size: 14px;
          font-weight: 400;
          color: rgba(51, 51, 51, 1);
        }
      }
      .ybTime {
        width: 150px;
        color: rgba(69, 69, 69, 1);
      }
    }
  }
  /* 页码样式开始 */
  /deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
    // 页码点击效果
    // background: #11a4ff;
    color: rgba(255, 255, 255, 1);
    border: 0px;
  }
  /deep/.el-pager li {
    // 页码样式
    min-width: 30px;
    height: 30px;
    border: 1px solid rgba(187, 187, 187, 1);
    border-radius: 2px;
    background: transparent;
    line-height: 30px;
    font-size: 14px;
    font-weight: 400;
  }
  /deep/.el-pagination button {
    // 页码上下页样式
    width: 68px;
    height: 30px;
    border: 1px solid rgba(187, 187, 187, 1);
    border-radius: 2px;
    line-height: 30px;
    font-size: 14px;
    background: transparent;
    color: rgba(102, 102, 102, 1);
    font-weight: 400;
  }
  /deep/.el-pagination button:hover {
    border: 1px solid rgba(128, 128, 128, 1);
  }
  /deep/.el-pagination button:active {
    background: rgba(224, 237, 252, 1);
    border: 1px solid rgba(187, 187, 187, 1);
  }
  .page {
    position: absolute;
    bottom: 0px;
    right: 0px;
  }
  /* 页码样式结束 */
}
</style>